export default __webpack_public_path__ + "static/media/chapter5.24735bee.svg";